export const COMMUNICATION_CHANNEL_VALUES = [
  "CALL",
  "WHATSAPP",
  "EMAIL",
  "MEETING",
] as const;

export type CommunicationChannel =
  (typeof COMMUNICATION_CHANNEL_VALUES)[number];

export const COMMUNICATION_CHANNEL_OPTIONS: {
  value: CommunicationChannel;
  label: string;
}[] = [
  { value: "CALL", label: "שיחה" },
  { value: "WHATSAPP", label: "וואטסאפ" },
  { value: "EMAIL", label: "מייל" },
  { value: "MEETING", label: "פגישה" },
];

export function communicationChannelLabel(
  value: string | null | undefined,
): string {
  return (
    COMMUNICATION_CHANNEL_OPTIONS.find((option) => option.value === value)
      ?.label ?? ""
  );
}

export function isCommunicationChannel(
  value: string | null | undefined,
): value is CommunicationChannel {
  return (
    value === "CALL" ||
    value === "WHATSAPP" ||
    value === "EMAIL" ||
    value === "MEETING"
  );
}

/** Invalid stored channels are cleared; empty/null stay as-is. */
export function sanitizeCommunicationChannel(
  channel: string | null | undefined,
): string | null | undefined {
  if (channel && !isCommunicationChannel(channel)) return null;
  return channel;
}
